import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uk-background-muted" }
const _hoisted_2 = {
  key: 0,
  class: "uk-dark uk-background-muted uk-container"
}
const _hoisted_3 = { class: "uk-alert-primary uk-text-secondary" }
const _hoisted_4 = { class: "uk-table uk-table-divider" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "uk-dark uk-background-muted uk-container"
}
const _hoisted_8 = { "uk-switcher": "animation: uk-animation-fade; toggle: > *; connect: .container-switcher" }
const _hoisted_9 = { class: "uk-align-center uk-margin-top" }
const _hoisted_10 = { class: "uk-flex uk-flex-center" }
const _hoisted_11 = {
  key: 0,
  class: "uk-subnav uk-subnav-pill uk-margin-remove-bottom",
  "uk-switcher": "connect: .switcher-container"
}
const _hoisted_12 = {
  key: 1,
  class: "uk-subnav uk-subnav-pill uk-margin-remove-bottom",
  "uk-switcher": "connect: .switcher-container"
}
const _hoisted_13 = {
  key: 2,
  class: "uk-subnav uk-subnav-pill uk-margin-remove-bottom",
  "uk-switcher": "connect: .switcher-container"
}
const _hoisted_14 = {
  key: 0,
  class: "uk-switcher switcher-container uk-margin"
}
const _hoisted_15 = {
  key: 1,
  class: "uk-switcher switcher-container uk-margin"
}
const _hoisted_16 = {
  key: 2,
  class: "uk-switcher switcher-container uk-margin"
}
const _hoisted_17 = { class: "uk-flex-inline uk-flex-column uk-text-left uk-margin-right" }
const _hoisted_18 = {
  key: 0,
  class: "uk-margin-right",
  "uk-spinner": ""
}
const _hoisted_19 = {
  key: 0,
  class: "uk-form-danger uk-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikisIcon = _resolveComponent("WikisIcon")!
  const _component_TrainIcon = _resolveComponent("TrainIcon")!
  const _component_DeliveryTruck = _resolveComponent("DeliveryTruck")!
  const _component_AddNewOrderForm = _resolveComponent("AddNewOrderForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isOpen) = $event)),
    modalId: "add-new-order-modal",
    maxWidth: "7xl",
    isClosableOnEsc: false,
    onClose: _ctx.onClose
  }, {
    title: _withCtx(() => [...(_cache[10] || (_cache[10] = [
      _createTextVNode("New Order", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.createdOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", null, "Created Order " + _toDisplayString(_ctx.createdOrder.id), 1),
                _createElementVNode("b", null, "Drop-Off: " + _toDisplayString(_ctx.createdOrder.receiver.name), 1),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("b", null, "Bill To : " + _toDisplayString(_ctx.createdOrder.billTo.name), 1),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("table", _hoisted_4, [
                  _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                    _createElementVNode("th", null, "Container Number"),
                    _createElementVNode("th", null, "Size/Type"),
                    _createElementVNode("th", null, "Terminal")
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdOrder.containers, (container, containerIdx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `fetched-container-${containerIdx}`
                      }, [
                        (container.containerId != 'EXPUNDEF')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(container.containerId), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_6, "Container Number not defined")),
                        _createElementVNode("td", null, _toDisplayString(container.sizeType), 1),
                        _createElementVNode("td", null, _toDisplayString(container.terminal), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[23] || (_cache[23] = _createElementVNode("h2", null, "New Order", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "uk-button switcher uk-button-default",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_IMPORT)))
                }, [
                  _createVNode(_component_WikisIcon),
                  _cache[14] || (_cache[14] = _createTextVNode(" Ocean ", -1))
                ]),
                _createElementVNode("button", {
                  class: "uk-button switcher uk-button-default",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_PICK_UP)))
                }, [
                  _createVNode(_component_TrainIcon),
                  _cache[15] || (_cache[15] = _createTextVNode(" Rail ", -1))
                ]),
                _createElementVNode("button", {
                  class: "uk-button switcher uk-button-default",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.LAND)))
                }, [
                  _createVNode(_component_DeliveryTruck),
                  _cache[16] || (_cache[16] = _createTextVNode(" Land ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isOceanOrder)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                        _createElementVNode("li", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_IMPORT)))
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("a", { href: "#" }, "Import", -1)
                        ]))]),
                        _createElementVNode("li", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_EXPORT)))
                        }, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("a", { href: "#" }, "Export", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isRailOrder)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                        _createElementVNode("li", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_PICK_UP)))
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("a", { href: "#" }, "Rail Pick-Up", -1)
                        ]))]),
                        _createElementVNode("li", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_DELIVERY)))
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("a", { href: "#" }, "Rail Delivery", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLandOrder)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                        _createElementVNode("li", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.LAND)))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("a", { href: "#" }, "Land Order", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isOceanOrder)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_AddNewOrderForm, {
                          onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
                          onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
                          billingCustomers: _ctx.billingCustomers,
                          receivingCustomers: _ctx.receivingCustomers,
                          activeBLs: _ctx.activeBLs,
                          orderData: _ctx.orderData,
                          orderType: _ctx.ORDER_TYPE.OCEAN_IMPORT,
                          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
                          settingsOrderShowLinkedOrderNumberField: 
                    _ctx.company && _ctx.company.settingsOrderShowLinkedOrderNumberField
                  ,
                          showVesselInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowVesselInformation
                  ,
                          settingsOrderShowEmergencyInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowEmergencyInformation
                  ,
                          settingsOrderLtlEnabled: 
                    _ctx.company && _ctx.company.settingsOrderLtlEnabled
                  ,
                          showBrokerFields: _ctx.company && _ctx.company.isBroker
                        }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "billingCustomers", "receivingCustomers", "activeBLs", "orderData", "orderType", "activeContainersWithoutOrder", "settingsOrderShowLinkedOrderNumberField", "showVesselInformation", "settingsOrderShowEmergencyInformation", "settingsOrderLtlEnabled", "showBrokerFields"])
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_AddNewOrderForm, {
                          onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
                          onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
                          billingCustomers: _ctx.billingCustomers,
                          receivingCustomers: _ctx.receivingCustomers,
                          activeBLs: _ctx.activeBLs,
                          orderData: _ctx.orderData,
                          orderType: _ctx.ORDER_TYPE.OCEAN_EXPORT,
                          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
                          showVesselInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowVesselInformation
                  ,
                          settingsOrderLtlEnabled: 
                    _ctx.company && _ctx.company.settingsOrderLtlEnabled
                  ,
                          settingsOrderShowEmergencyInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowEmergencyInformation
                  ,
                          showBrokerFields: _ctx.company && _ctx.company.isBroker
                        }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "billingCustomers", "receivingCustomers", "activeBLs", "orderData", "orderType", "activeContainersWithoutOrder", "showVesselInformation", "settingsOrderLtlEnabled", "settingsOrderShowEmergencyInformation", "showBrokerFields"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isRailOrder)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_AddNewOrderForm, {
                          onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
                          onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
                          billingCustomers: _ctx.billingCustomers,
                          receivingCustomers: _ctx.receivingCustomers,
                          activeBLs: _ctx.activeBLs,
                          orderData: _ctx.orderData,
                          orderType: _ctx.ORDER_TYPE.RAIL_PICK_UP,
                          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
                          settingsOrderShowLinkedOrderNumberField: 
                    _ctx.company && _ctx.company.settingsOrderShowLinkedOrderNumberField
                  ,
                          showVesselInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowVesselInformation
                  ,
                          settingsOrderShowEmergencyInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowEmergencyInformation
                  ,
                          settingsOrderLtlEnabled: 
                    _ctx.company && _ctx.company.settingsOrderLtlEnabled
                  ,
                          showBrokerFields: _ctx.company && _ctx.company.isBroker
                        }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "billingCustomers", "receivingCustomers", "activeBLs", "orderData", "orderType", "activeContainersWithoutOrder", "settingsOrderShowLinkedOrderNumberField", "showVesselInformation", "settingsOrderShowEmergencyInformation", "settingsOrderLtlEnabled", "showBrokerFields"])
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_AddNewOrderForm, {
                          onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
                          onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
                          billingCustomers: _ctx.billingCustomers,
                          receivingCustomers: _ctx.receivingCustomers,
                          activeBLs: _ctx.activeBLs,
                          orderData: _ctx.orderData,
                          orderType: _ctx.ORDER_TYPE.RAIL_DELIVERY,
                          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
                          showVesselInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowVesselInformation
                  ,
                          settingsOrderShowEmergencyInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowEmergencyInformation
                  ,
                          settingsOrderLtlEnabled: 
                    _ctx.company && _ctx.company.settingsOrderLtlEnabled
                  ,
                          showBrokerFields: _ctx.company && _ctx.company.isBroker
                        }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "billingCustomers", "receivingCustomers", "activeBLs", "orderData", "orderType", "activeContainersWithoutOrder", "showVesselInformation", "settingsOrderShowEmergencyInformation", "settingsOrderLtlEnabled", "showBrokerFields"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isLandOrder)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_AddNewOrderForm, {
                          onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
                          onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
                          billingCustomers: _ctx.billingCustomers,
                          receivingCustomers: _ctx.receivingCustomers,
                          activeBLs: _ctx.activeBLs,
                          orderData: _ctx.orderData,
                          orderType: _ctx.ORDER_TYPE.LAND,
                          activeContainersWithoutOrder: _ctx.activeContainersWithoutOrder,
                          settingsOrderShowLinkedOrderNumberField: 
                    _ctx.company && _ctx.company.settingsOrderShowLinkedOrderNumberField
                  ,
                          showVesselInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowVesselInformation
                  ,
                          settingsOrderShowEmergencyInformation: 
                    _ctx.company && _ctx.company.settingsOrderShowEmergencyInformation
                  ,
                          settingsOrderLtlEnabled: 
                    _ctx.company && _ctx.company.settingsOrderLtlEnabled
                  ,
                          showBrokerFields: _ctx.company && _ctx.company.isBroker
                        }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "billingCustomers", "receivingCustomers", "activeBLs", "orderData", "orderType", "activeContainersWithoutOrder", "settingsOrderShowLinkedOrderNumberField", "showVesselInformation", "settingsOrderShowEmergencyInformation", "settingsOrderLtlEnabled", "showBrokerFields"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "uk-form-label" }, _toDisplayString('\xa0'), -1)),
                _createElementVNode("button", {
                  class: "uk-button uk-button-primary uk-form-controls",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addNewOrder && _ctx.addNewOrder(...args)))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.orderCreationButtonText), 1)
                ]),
                (_ctx.validationError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.validationError), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "onClose"]))
}